@if (isPageActive()) {
<div class="fdx-o-grid fdx-o-grid--max-width">
  <app-page-header [title]="'Wybierz sposób nadania twojej przesyłki'">
    @if (isShippingPoint()) { @if (storeService.isShippingPickupPointPosible())
    { Twoja przesyłka spełnia warunki, by nadać ją w Punkcie Partnerskim FedEx.
    } @else { Twoja przesyłka nie spełnia warunków do nadania w Punkcie
    Partnerskim FedEx. Zamów kuriera po odbiór przesyłki. } } @if
    (isShippingCourier()) { @if (storeService.isShippingPickupPointPosible() &&
    !isLabelReady()) { Wprowadź dane adresowe nadawcy, uzupełniając pola
    obowiązkowe. } @else { Twoja przesyłka nie spełnia warunków do nadania w
    Punkcie Partnerskim FedEx. Zamów kuriera po odbiór przesyłki. } }
  </app-page-header>

  <app-main-option-buttons-wrapper>
    <app-main-option-button
      class="fdx-o-grid__item--4 fdx-o-grid__item--3@medium"
      (click)="sendOnPointButtonAction()"
      [label]="'Nadaj w punkcie'"
      [iconPathForActiveButton]="'assets/images/station_icon_white.png'"
      [iconPathForInActiveButton]="'assets/images/station_icon_grey.png'"
      [isActive]="isShippingPoint()"></app-main-option-button>
    <app-main-option-button
      class="fdx-o-grid__item--4 fdx-o-grid__item--3@medium"
      (click)="orderCourierButtonAction()"
      [label]="'Zamów kuriera'"
      [iconPathForActiveButton]="'assets/images/courier_icon_white.png'"
      [iconPathForInActiveButton]="'assets/images/courier_icon_grey.png'"
      [isActive]="isShippingCourier()"></app-main-option-button>
  </app-main-option-buttons-wrapper>

  @if (!this.storeService.getSender()) {
  <app-form-header>
    @if (isShippingPoint() && storeService.isShippingPickupPointPosible()) {
    List przewozowy będziesz mógł pobrać w ostatnim etapie procesu
    <b>Szczegóły nadania</b>. } @if (isShippingCourier()) { List przewozowy
    będziesz mógł pobrać w ostatnim etapie procesu <b>Potwierdzenie</b>. }
  </app-form-header>
  } @if (isShippingPoint()) {
  <app-shipping-point-form></app-shipping-point-form>
  } @if (isShippingCourier()) {
  <app-shipping-courier-form></app-shipping-courier-form>
  }
</div>
}
